export type AchievementResponse = {
	pastAchievements: Achievement[]
	actualAchievements: Achievement[],
	comingSoonAchievements?: Achievement[],
	batchId: number
};

export type ActiveAchievementResponse = {
	achievements: Achievement[]
};

export type CollectAchievementResponse = {
	success: boolean,
	failureReason: FailureReason | undefined
};

export type ActivatedAchievementResponse = {
	success: boolean,
	failureReason: FailureReason | undefined
};

export enum FailureReason {
	NOTIFICATION_FAILURE = 'NOTIFICATION_FAILURE',
	GENERIC_FAILURE = 'GENERIC_FAILURE',
	CUSTOMER_HAS_NO_ACHIEVEMENT = 'CUSTOMER_HAS_NO_ACHIEVEMENT'
}

export type Achievement = {
	achievementId: string,
	name: string,
	content: AchievementContent,
	progress: AchievementProgress
};

export type AchievementContent = {
	card: AchievementContentCard,
	instructions: AchievementContentInstructions,
	showFeedback: boolean,
	sponsor?: string
};

export type AchievementContentCard = {
	completionGoal: number,
	progressBarColor: string,
	progressBarType: AchievementProgressBarType,
	title: string,
	description: string,
	compensationAmount: number,
	expirationDate: string
};

export type AchievementHeadlineInfo = {
	text: string;
	ariaLabel?: string
};

export type AchievementContentInstructions = {
	headerHeadline: string,
	headerBackgroundColor: string,
	headerTextColor: string,
	headerIconUrl?: string,
	headerBrandName?: string,
	bodyExplanations: string[],
	footerNotes: string,
	actionText: string,
	actionLink: string,
	actionIconRight: boolean,
	actionType: AchievementInstructionActionType,
	actionSheetTitle: string,
	needsActivation: boolean,
};

export type AchievementProgress = {
	state: AchievementProgressState,
	current: number
};

export enum AchievementProgressBarType {
	DONUT = 'DONUT'
}

export enum AchievementProgressState {
	CREATED = 'CREATED',
	ACTIVE = 'ACTIVE',
	ACTIVATED = 'ACTIVATED',
	COLLECTED = 'COLLECTED',
	COLLECTABLE = 'COLLECTABLE',
	EXPIRED = 'EXPIRED',
	COMING_SOON = 'COMING_SOON'
}

export enum AchievementInstructionActionType {
	OPEN_SHEET = 'OPEN_SHEET',
	OPEN_LINK = 'OPEN_LINK',
	CLOSE = 'CLOSE',
	NONE = 'NONE'
}
